/**
 * Reducers
 *
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */

import { combineReducers } from 'redux';
import { alert } from './alert';
import { announcements } from './announcements';
import { artistHistory } from './artistHistory';
import { audience } from './audience';
import { concertView } from './concertView';
import { currentSong } from './currentSong';
import { identity } from './identity';
import { platform } from './platform';
import { song } from './song';
import { topTracks } from './topTracks';
import { viewport } from './viewport';

export const reducer = combineReducers({
  alert,
  announcements,
  artistHistory,
  audience,
  concertView,
  currentSong,
  identity,
  platform,
  song,
  topTracks,
  viewport,
});
